import { mergeAttributes, Node } from "@tiptap/core";
import { NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import React from "react";

const SectionView = ({ node }) => (
  <NodeViewWrapper className="client-history-section" data-id-part={node.attrs.idPart}>
    <div className="client-history-section__title" contentEditable={false} draggable={false}>
      {node.attrs.name}
    </div>
    <NodeViewContent className="client-history-section__body" as="div" />
  </NodeViewWrapper>
);

/**
 * Раздел истории: название фиксировано (отдельная строка), редактируется только тело.
 */
export const HistorySection = Node.create({
  name: "historySection",
  group: "block",
  content: "block+",
  defining: true,
  isolating: true,
  draggable: false,

  addAttributes() {
    return {
      idPart: {
        default: null,
        parseHTML: (element) => Number(element.getAttribute("data-id-part")) || null,
        renderHTML: (attributes) => ({ "data-id-part": attributes.idPart })
      },
      name: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-name") || "",
        renderHTML: (attributes) => ({ "data-name": attributes.name })
      }
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="history-section"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "history-section" }), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(SectionView);
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("historySectionGuard"),
        filterTransaction: (tr, state) => {
          if (!tr.docChanged) return true;

          const count = (doc) => {
            let n = 0;
            doc.forEach((node) => {
              if (node.type.name === this.name) n += 1;
            });
            return n;
          };

          if (count(tr.doc) !== count(state.doc)) return false;

          // Запрет смены idPart / name у разделов.
          let ok = true;
          const before = [];
          state.doc.forEach((node) => {
            if (node.type.name === this.name) {
              before.push({ idPart: node.attrs.idPart, name: node.attrs.name });
            }
          });
          let i = 0;
          tr.doc.forEach((node) => {
            if (node.type.name !== this.name) return;
            const prev = before[i];
            i += 1;
            if (!prev) {
              ok = false;
              return;
            }
            if (prev.idPart !== node.attrs.idPart || prev.name !== node.attrs.name) {
              ok = false;
            }
          });
          return ok;
        }
      })
    ];
  }
});
